import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '../utils/auth'

Vue.use(VueRouter)

import Layout from '../layout'
import Login from '../views/login'
import Dashboard from '../views/dashboard'
import User from '../views/user'
import Certification from '../views/certification'
import City from '../views/city'
import Category from '../views/category'
import Post from '../views/post'
import ViolationWord from '../views/violation-word'
import FeeRule from '../views/fee-rule'
import Revenue from '../views/revenue'
import Report from '../views/report'
import Banner from '../views/banner'
import HotSearch from '../views/hot-search'
import System from '../views/system'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: Dashboard, meta: { title: '工作台' } },
      { path: 'users', name: 'User', component: User, meta: { title: '用户管理' } },
      { path: 'certifications', name: 'Certification', component: Certification, meta: { title: '认证管理' } },
      { path: 'cities', name: 'City', component: City, meta: { title: '城市管理' } },
      { path: 'categories', name: 'Category', component: Category, meta: { title: '分类管理' } },
      { path: 'posts', name: 'Post', component: Post, meta: { title: '帖子管理' } },
      { path: 'violation-words', name: 'ViolationWord', component: ViolationWord, meta: { title: '违规词库' } },
      { path: 'fee-rules', name: 'FeeRule', component: FeeRule, meta: { title: '发帖时效' } },
      { path: 'revenue', name: 'Revenue', component: Revenue, meta: { title: '收入统计' } },
      { path: 'reports', name: 'Report', component: Report, meta: { title: '举报管理' } },
      { path: 'banners', name: 'Banner', component: Banner, meta: { title: '广告管理' } },
      { path: 'hot-search', name: 'HotSearch', component: HotSearch, meta: { title: '热搜词管理' } },
      { path: 'system', name: 'System', component: System, meta: { title: '系统配置' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫
const whiteList = ['/login']
router.beforeEach((to, from, next) => {
  const token = getToken()
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

export default router
